var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-21a3d586-ec1c-4659-a5a5-8db0affb117a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858.9913 15.1064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-39b49952-55ce-4755-a207-e577c3c04cc5",
    "data-name": "line_2"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 858.9913,
    y2: 2,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "445.7872 2 434.6808 13.1064 269.617 13.1064 104.5532 13.1064 93.4468 2",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "790.5693 2 779.4629 13.1064 614.3991 13.1064 569.6431 13.1064 558.5367 2",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.0792,
    y1: 9.5426,
    x2: 437.5343,
    y2: 9.5426,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.1962,
    y1: 13.1064,
    x2: 325.5154,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.3665,
    y1: 13.1064,
    x2: 317.6856,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.8318,
    y1: 13.1064,
    x2: 602.1509,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 606.002,
    y1: 13.1064,
    x2: 594.3211,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.223038d465b77c5d8cba42b62a7bb828.svg";
export { ForwardRef as ReactComponent };